// extracted by mini-css-extract-plugin
module.exports = {"footer":"styles_footer__3EvVX","content":"styles_content__1K88L","checkbox":"styles_checkbox__3U6WR","checkboxLabel":"styles_checkboxLabel__2PIcr"};